export const STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
}
